import { arrayOf, string } from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

export class LazyAssetRenderer extends PureComponent {
  constructor(props) {
    super(props);
    this.injected = {
      js: [],
      css: []
    };
  }

  componentDidMount() {
    this.props.js.map(this._appendJs);
    this.props.css.map(this._appendCss);
  }

  componentDidUpdate() {
    this.props.js.map(this._appendJs);
    this.props.css.map(this._appendCss);
  }

  _appendJs = (src) => {
    if (this.injected.js.includes(src)) {
      // Already injected
      return;
    }
    const node = document.createElement('script');
    node.src = src;
    node.async = true;
    document.body.appendChild(node);
    this.injected.js.push(src);
  };

  _appendCss = (href) => {
    if (this.injected.css.includes(href)) {
      // Already injected
      return;
    }
    const node = document.createElement('link');
    node.href = href;
    node.rel = 'stylesheet';
    document.head.appendChild(node);
    this.injected.css.push(href);
  };

  render() {
    return null;
  }
}

LazyAssetRenderer.defaultProps = {
  css: [],
  js: []
};

LazyAssetRenderer.propTypes = {
  css: arrayOf(string),
  js: arrayOf(string)
};

export default connect(({ assets }) => ({
  css: assets.css,
  js: assets.js
}))(LazyAssetRenderer);
